/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/align-right-3";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "AlignRight3";
export { I as AlignRight3 };
